const support = () => import(/* webpackChunkName: "support" */ '@/components/support/support/support.vue');
const helpAndSupport = () => import(/* webpackChunkName: "support" */ '@/components/support/help-and-support/help-and-support.vue');
const learnTheBasics = () => import(/* webpackChunkName: "support" */ '@/components/support/learn-the-basics/learn-the-basics.vue');
const communityForums = () => import(/* webpackChunkName: "support" */ '@/components/support/community-forums/community-forums.vue');
const faq = () => import(/* webpackChunkName: "support" */ '@/components/support/faq/faq.vue');
const whatIsPredictIt = () => import(/* webpackChunkName: "support" */ '@/components/support/what-is-predictit/what-is-predictit.vue');
const videos = () => import(/* webpackChunkName: "support" */ '@/components/support/videos/videos.vue');

export default [

  {
    path: '/support',
    component: support,
    props: true,
    children: [
      {
        path: '',
        name: 'HelpAndSupport',
        component: helpAndSupport,
        props: true,
      },
      {
        path: 'what-is-predictit',
        name: 'WhatIsPredictIt',
        component: whatIsPredictIt,
        props: true,
      },
      {
        path: 'how-to-trade-on-predictit',
        name: 'LearnTheBasics',
        component: learnTheBasics,
        props: true,
      },
      {
        path: 'community-forums',
        name: 'ComunityForums',
        component: communityForums,
        props: true,
      },
      {
        path: 'faq',
        name: 'Faq',
        component: faq,
        props: true,
      },
      {
        path: 'videos',
        name: 'Videos',
        component: videos,
        props: true,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/support.js